import { ReactNode } from 'react';

import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div
      className="empty-state flex flex-col items-center justify-center px-4 py-8 sm:px-6 sm:py-12 text-center"
      role="status"
      aria-live="polite"
    >
      {icon && (
        <div className="empty-state-icon mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-muted text-muted-foreground [&_svg]:h-7 [&_svg]:w-7">
          {icon}
        </div>
      )}
      <h6 className="empty-state-title text-lg font-semibold mb-2">
        {title}
      </h6>
      {description && (
        <p className={`empty-state-description text-sm text-muted-foreground max-w-[300px] ${action ? 'mb-6' : ''}`}>
          {description}
        </p>
      )}
      {action && (
        <Button onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
